import _toLower from 'lodash/toLower';
import * as Sentry from '@sentry/react';
import { createBrowserHistory } from 'history';

const ENV = import.meta.env.VITE_ENV;
const isDevelopment = ENV === 'DEVELOPMENT';

export const history = createBrowserHistory();

if (!isDevelopment) {
  const defaultOptions = {
    dsn: 'https://0eb1568ea93c4679bcee693ea86dff1a@o89831.ingest.sentry.io/5774579',
    integrations: [Sentry.reactRouterV5BrowserTracingIntegration({ history })],
    environment: _toLower(ENV),
    tracesSampleRate: 1.0,
  };
  const mergedOptions = {
    ...defaultOptions,
    ...(ENV === 'PRODUCTION'
      ? {
          beforeSend(event) {
            // Check if the stacktrace exists and has frames
            if (event.exception && event.exception.values) {
              for (const exception of event.exception.values) {
                if (exception.stacktrace && exception.stacktrace.frames) {
                  for (const frame of exception.stacktrace.frames) {
                    // Check if the frame's filename originates from 'https://maps.googleapis.com'
                    if (
                      frame.filename &&
                      frame.filename.startsWith('https://maps.googleapis.com')
                    ) {
                      return null; // Drop the event and don't send to Sentry
                    }
                  }
                }
              }
            }

            if (event.exception && !event.contexts?.feedbackDialog?.hide) {
              Sentry.showReportDialog({ eventId: event.event_id });
            }
            return event;
          },
        }
      : {}),
  };

  Sentry.init(mergedOptions);
}
